import * as React from 'react'
import { FieldProps } from 'formik'
import { Input } from '../Input'
import { TextFontWeight } from '$utils/theme/font'

interface Props {
  label: string
  type: string
  placeholder?: string
  primary?: boolean
  secondary?: boolean
  small?: boolean
  info?: boolean
  infoText?: string
  icon?: string
  onBlur: (event) => void
  maxLength?: number
  weight?: TextFontWeight
  hasError: boolean
  width: number
  step?: string
}

export const FormiikField: React.SFC<Props & FieldProps<any>> = ({ field, ...props }) => {
  if (props.form.touched[field.name] && props.form.errors[field.name] && !props.hasError) {
    return (
      <Input
        {...field}
        type={props.type}
        placeholder={props.placeholder}
        onBlur={props.onBlur}
        label={props.label}
        primary={props.primary}
        secondary={props.secondary}
        small={props.small}
        error={true}
        errorText={props.form.errors[field.name]}
        info={props.info}
        icon={props.icon}
        infoText={props.infoText}
        maxLength={props.maxLength}
        weight={props.weight}
        width={props.width}
        step={props.step}
      />
    )
  }
  return (
    <Input
      {...field}
      type={props.type}
      placeholder={props.placeholder}
      label={props.label}
      onBlur={props.onBlur}
      primary={props.primary}
      secondary={props.secondary}
      small={props.small}
      info={props.info}
      icon={props.icon}
      infoText={props.infoText}
      maxLength={props.maxLength}
      weight={props.weight}
      width={props.width}
      step={props.step}
    />
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Forms/FormiikField.tsx